// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"u2-z","displaySixCardTiles":"v2-z"};